// Rice export catalogue

export const PRODUCTS = [
  {
    id: "basmati-rice",
    sku: "QG-RC-001",
    name: "Basmati Rice",
    category: "Rice",
    description:
      "Authentic Basmati rice with long grains and aromatic fragrance. Aged for optimal flavor and texture.",
    grades: ["Super Basmati", "Basmati 385", "Basmati D-98"],
    granulation: ["Long grain (7-8mm)", "Extra long (8-9mm)"],
    packaging: ["25kg PP bags", "50kg jute bags", "1 MT bulk", "Private label"],
    moq: "50 MT (2x20ft containers)",
    image:
      "https://images.pexels.com/photos/7363674/pexels-photo-7363674.jpeg?auto=compress&cs=tinysrgb&w=900&h=675&fit=crop",
  },
  {
    id: "white-rice",
    sku: "QG-RC-002",
    name: "White Rice",
    category: "Rice",
    description:
      "Premium polished white rice. Perfectly milled for consistent quality and cooking performance.",
    grades: ["Premium A", "Standard B", "Economy"],
    granulation: ["Short grain", "Medium grain", "Long grain"],
    packaging: ["10kg bags", "25kg bags", "50kg bags", "Bulk containers"],
    moq: "40 MT",
    image:
      "https://images.pexels.com/photos/1059943/pexels-photo-1059943.jpeg?auto=compress&cs=tinysrgb&w=900&h=675&fit=crop",
  },
  {
    id: "brown-rice",
    sku: "QG-RC-003",
    name: "Brown Rice",
    category: "Rice",
    description:
      "Whole grain brown rice with natural bran layer intact. Rich in fiber and nutrients.",
    grades: ["Organic", "Premium", "Standard"],
    granulation: ["Short grain", "Medium grain", "Long grain"],
    packaging: ["25kg bags", "50kg bags", "Custom retail"],
    moq: "30 MT",
    image:
      "https://images.pexels.com/photos/7363676/pexels-photo-7363676.jpeg?auto=compress&cs=tinysrgb&w=900&h=675&fit=crop",
  },
  {
    id: "parboiled-rice",
    sku: "QG-RC-004",
    name: "Parboiled Rice",
    category: "Rice",
    description:
      "Partially pre-cooked rice that retains more nutrients. Ideal for bulk catering and food services.",
    grades: ["Premium", "Standard"],
    granulation: ["Long grain", "Medium grain"],
    packaging: ["25kg PP bags", "50kg bags", "Bulk"],
    moq: "50 MT",
    image:
      "https://images.pexels.com/photos/6644072/pexels-photo-6644072.jpeg?auto=compress&cs=tinysrgb&w=900&h=675&fit=crop",
  },
];

export const getProductById = (id) => PRODUCTS.find((p) => p.id === id);
